{
  "recordingDashboard": {
    "title": "Aufnahme-Cockpit",
    "subtitle": "Steuere den Aufnahmefortschritt aller Prozesse und kläre offene Zuweisungen.",
    "progress": {
      "title": "Aufnahmefortschritt ({{count}} Prozesse)",
      "completed": "Abgeschlossen",
      "inRecording": "In Aufnahme",
      "recordingComplete": "Aufgenommen",
      "notStarted": "Nicht gestartet",
      "pendingAssignment": "Ausstehend"
    },
    "tabs": {
      "notStarted": "Nicht gestartet",
      "inRecording": "In Aufnahme",
      "completed": "Abgeschlossen"
    },
    "notStarted": {
      "startRecording": "Aufnahme starten",
      "overdue": "Überfällig",
      "noProcesses": "Alle Prozesse wurden gestartet."
    },
    "inRecording": {
      "reassign": "Neu zuweisen",
      "noProcesses": "Derzeit werden keine Prozesse aufgenommen.",
      "pendingStep": "Ausstehende Zuweisung",
      "openStep": "Offener Schritt"
    },
    "completed": {
      "noProcesses": "Noch keine abgeschlossenen Prozesse."
    },
    "surveys": {
      "pending": "Ausstehend",
      "completed": "Abgeschlossen",
      "dismissed": "Macht den Schritt nicht"
    },
    "actions": {
      "openProcess": "Zum Prozess öffnen",
      "toggleDetails": "Details ein-/ausklappen"
    },
    "columns": {
      "process": "Prozess",
      "owner": "Verantwortlicher",
      "status": "Status",
      "statusRecording": "Aufnahme Status",
      "step": "Schritt",
      "actions": "Aktionen",
      "unassigned": "Nicht zugewiesen",
      "dueDate": "Fälligkeitsdatum",
      "type": "Typ",
      "assignee": "Zuständig"
    },
    "subTable": {
      "step": "Schritt",
      "survey": "Umfrage",
      "hideCompleted": "Abgeschlossene ausblenden",
      "assignment": "Zuweisung",
      "cannotNudgeNonPerson": "Du kannst nur Personen erinnern."
    },
    "status": {
      "openAssignments_one": "{{count}} ausstehende Zuweisung",
      "openAssignments_other": "{{count}} ausstehende Zuweisungen",
      "inRecordingSteps": "{{count}} Schritte in Aufnahme",
      "pendingSurveys": "{{count}} ausstehende Umfragen",
      "overdue": "{{count}} überfällig",
      "stepsComplete": "{{completed}}/{{total}} Schritte aufgenommen",
      "stepsTooltip": "Aufgenommene Schritte / Gesamt bekannte Schritte"
    },
    "nudge": {
      "title": "Erinnerung senden",
      "description": "Sende eine Erinnerung an {{name}} bezüglich der Aufnahmeaufgabe für {{process}}.",
      "messagePlaceholder": "Persönliche Nachricht hinzufügen...",
      "send": "Erinnerung senden",
      "success": "Erinnerung erfolgreich gesendet."
    }
  }
}
